import { getAmount } from 'libs/common';
import { getMeanType } from 'services/types';

export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      {
        name: 'client_name',
        sortField: 'client_name',
        title: t('form.ФИО'),
        width: 270,
      },
      {
        name: 'contract_number',
        title: t('filter.№ договора паркирования'),
        width: 220,
      },
      {
        name: 'mean_type',
        title: t('dict_filter.Тип'),
        width: 150,
        render: (val) => getMeanType(val),
      },
      {
        name: 'mean_number',
        title: t('buttons.Номер'),
        width: 170,
      },
      {
        name: 'debt',
        title: t('grid.Долг'),
        render: (val) => getAmount(val),
      },
      {
        name: 'is_payed',
        title: t('grid.Статус оплаты'),
        width: 140,
        render: (val) => (val ? 'Оплачено' : 'Не оплачено'),
      },
    ];

    return fields;
  };

  return { getFields };
};
